import styled from 'styled-components'

import { Del } from 'icon'

const KeyBoard = (props) => {
  const { onClick, onDelete } = props

  const getBtn = (list = []) => {
    return list.map((it, i) => {
      const { status, label, text } = it
      if (status === 'space') return <SpaceBtn key={i} />
      if (status === 'delete') {
        return (
          <DelBtn key={i} onClick={onDelete}>
            <Del size={0.8} color="#000000" />
          </DelBtn>
        )
      }

      const click = () => onClick(label)
      return (
        <Btn key={i} onClick={click}>
          {label}
          <Text>{text}</Text>
        </Btn>
      )
    })
  }
  return (
    <Content>
      <LineBtn>{getBtn(menuA)}</LineBtn>
      <LineBtn>{getBtn(menuB)}</LineBtn>
      <LineBtn>{getBtn(menuC)}</LineBtn>
      <LineBtn>{getBtn(menuD)}</LineBtn>
    </Content>
  )
}

const menuA = [
  { label: '1', text: '' },
  { label: '2', text: 'A B C' },
  { label: '3', text: 'D E F' },
]

const menuB = [
  { label: '4', text: 'G H I' },
  { label: '5', text: 'J K L' },
  { label: '6', text: 'M N O' },
]

const menuC = [
  { label: '7', text: 'P Q R S' },
  { label: '8', text: 'T U V' },
  { label: '9', text: 'W X Y Z' },
]

const menuD = [
  { status: 'space' },
  { label: '0', text: '' },
  { status: 'delete' },
]

const Content = styled.div`
  width: 100%;
  background-color: #d1d3d9;
  border-radius: 8px;
  padding: 10px 0px;
`

const LineBtn = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 8px;
  padding: 4px 0px;
`

const Btn = styled.div`
  width: 30%;
  height: 53px;
  font-weight: 400;
  font-size: 25px;
  line-height: 30px;
  color: #3a4248;
  background-color: #ffffff;
  box-shadow: 0px 1px 0px #898a8d;
  border-radius: 5px;
  text-align: center;
  padding: 4px 0px;
  cursor: pointer;
`

const SpaceBtn = styled(Btn)`
  background-color: #d1d3d9;
  box-shadow: none;
`

const DelBtn = styled(Btn)`
  background-color: #d1d3d9;
  box-shadow: none;
  font-size: 20px;
  line-height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Text = styled.div`
  width: 100%;
  font-weight: 700;
  font-size: 10px;
  line-height: 12px;
  padding-top: 2px;
`

export default KeyBoard
